import { CommonCountryResponse, CommonMunicipalityResponse, CommonProvinceResponse } from '@/api/services/common.dto'
import { Nullable, StrictNullable } from '@/shared/types/app.types'
import {
    PredefinedCustomNotificationResponse
} from '@/modules/configurationModule/detail/notifications/services/predefined-custom-notification/predefined-custom-notification.dto'
import { ReportTemplateResponse } from '@/api/services/configuration/report-templates/report-templates.dto'

export interface ConfigurationLocalAccountingCustomersModalContactInformationState {
    description: Nullable<string>
    address: Nullable<string>
    postalCode: Nullable<string>
    country: Nullable<CommonCountryResponse>
    province: Nullable<CommonCountryResponse>
    municipality: Nullable<CommonCountryResponse>
    contactName: Nullable<string>
    mainPhone: Nullable<string>
    email: Nullable<string>
    phone1: Nullable<string>
    phone2: Nullable<string>
    emailNotification: Nullable<string>
    emailNotificationEnabled: boolean
    phoneNotification: Nullable<string>
    smsNotificationEnabled: boolean
    countries: CommonCountryResponse[]
    provinces: CommonProvinceResponse[]
    municipalities: CommonMunicipalityResponse[]
    breakdownDeliveryNotesByCaseType: boolean
    breakdownDeliveryNotesByPatient: boolean
    breakdownDeliveryNotesByRegime: boolean
    predefinedCustomNotificationForAuthorization: Nullable<PredefinedCustomNotificationResponse>
    reportInvoice: StrictNullable<ReportTemplateResponse>
    reportDeliveryNote: StrictNullable<ReportTemplateResponse>
}
export const initialConfigurationLocalAccountingCustomersModalContactInformationState =
    (): ConfigurationLocalAccountingCustomersModalContactInformationState => ({
        description: '',
        address: '',
        postalCode: '',
        country: null,
        province: null,
        municipality: null,
        contactName: '',
        mainPhone: '',
        email: '',
        phone1: '',
        phone2: '',
        emailNotification: '',
        emailNotificationEnabled: false,
        phoneNotification: '',
        smsNotificationEnabled: false,
        countries: [],
        provinces: [],
        municipalities: [],
        breakdownDeliveryNotesByCaseType: false,
        breakdownDeliveryNotesByPatient: false,
        breakdownDeliveryNotesByRegime: false,
        predefinedCustomNotificationForAuthorization: null,
        reportDeliveryNote: null,
        reportInvoice: null
    })
